import { TextField } from '@origin-digital/style-guide';
import React from 'react';
import analytics from '../../../../analytics';

import { TextFieldAdapterProps } from './TextFieldAdapter.types';

const TextFieldAdapter = (props: TextFieldAdapterProps): JSX.Element => {
  const { field, form, label, maxLength, transform, helpText, onFieldChange } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    field.onChange(event);
    if (onFieldChange) {
      onFieldChange(field.name, event.currentTarget.value);
    }
  };

  return (
    <TextField
      data-lpignore={true}
      name={field.name}
      value={field.value}
      label={label}
      maxLength={maxLength}
      transform={transform}
      onChange={handleChange}
      onBlur={field.onBlur}
      helpText={helpText}
      touched={form.errors[field.name] !== undefined && form.touched[field.name]}
      error={form.errors[field.name]}
      //@ts-ignore
      onClick={e => {
        analytics.firstInteraction();
      }}
    />
  );
};

export { TextFieldAdapter as default };
